<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">用户列表</div>

      <div class="search-wrapper">
         <el-form label-width="60px" :inline="true" :model="queryParam">
            <el-form-item label="性别">
               <el-select v-model="queryParam.gender" placeholder="请选择" style="width: 200px">
                  <el-option v-for="(item, index) in gender" :key="index" :label="item" :value="index - 1" />
               </el-select>
            </el-form-item>
            <el-form-item label="角色">
               <el-select v-model="queryParam.roleId" placeholder="请选择" style="width: 200px">
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option label="普通用户" :value="0"></el-option>
                  <el-option v-for="item in roles" :key="item.value" :label="item.label"
                     :value="item.value"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="校区">
               <el-select v-model="queryParam.unid" filterable placeholder="请选择" style="width: 200px">
                  <el-option v-for="item in campuszones" :key="item.value" :label="item.label"
                     :value="item.value"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="状态">
               <el-select v-model="queryParam.inviteStatus" placeholder="请选择" style="width: 200px">
                  <el-option v-for="(item, index) in inviteStatus" :key="item" :label="item"
                     :value="index - 1"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="用户">
               <el-input v-model="queryParam.searchKey" placeholder="请输入昵称或姓名或手机搜索" />
            </el-form-item>
         </el-form>
         <el-button class="margin-left-10" type="primary" @click="queryList">搜索</el-button>
         <el-button @click="clickReset">重置</el-button>
      </div>

      <div class="action-wrapper">
         <el-button @click="clickTemplateDownload">模版下载</el-button>
         <el-upload :show-file-list="false" :with-credentials="true" accept=".xls,.xlsx" :action="actionUrl"
            name="uploadFile" :before-upload="beforeUpload" :on-success="onSuccess" :on-error="onError">
            <el-button type="primary">导入赠送</el-button>
         </el-upload>
      </div>

      <div class="content-wrapper">
         <el-table :data="tableData" border>
            <el-table-column prop="uid" label="用户id" align="center" />
            <el-table-column label="用户" align="center" inline-template>
               <template>{{ row.nickname }}（{{ row.name }}）</template>
            </el-table-column>
            <el-table-column label="性别" align="center" inline-template>
               <template>{{ gender[row.gender + 1] }}</template>
            </el-table-column>
            <el-table-column prop="username" label="手机" align="center" />
            <el-table-column prop="rname" label="角色" align="center" />
            <el-table-column prop="unname" label="校区" align="center" />
            <el-table-column label="最近登录时间" align="center" inline-template width="170px">
               <div>{{ new Date(row.updatedAt).format("yyyy-MM-dd hh:mm:ss") }}</div>
            </el-table-column>
            <el-table-column label="邀请状态" align="center" inline-template>
               <template>
                  <div v-if="[0, 2].includes(row.inviteStatus)">可邀请</div>
                  <div v-if="[1, 3].includes(row.inviteStatus)">
                     已邀请（{{ row.type }}）
                  </div>
                  <div v-if="[4].includes(row.inviteStatus)">不可邀请</div>
                  <div v-if="[5].includes(row.inviteStatus)">
                     已拒绝（{{ row.type }}）
                  </div>
               </template>
            </el-table-column>
            <el-table-column inline-template label="操作" width="210px" align="center">
               <template>
                  <el-button style="color: red;" type="text" @click="clickRevoke(row)"
                     v-if="[1, 3, 5].includes(row.inviteStatus)">撤销</el-button>
                  <el-button type="text" @click="clickInvitation(row)"
                     v-if="[0, 2].includes(row.inviteStatus)">发送邀请</el-button>
                  <el-button type="text" @click="clickChangeType(row)"
                     v-if="[0, 2, 4].includes(row.inviteStatus)">变更类型</el-button>
                  <el-button type="text" @click="clickDonate(row)">赠送</el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination-wrapper">
         <el-pagination layout="total, prev, pager, next, jumper" :current-page.sync="queryParam.pageNum"
            :page-size="queryParam.pageSize" :total="tableTotal" @current-change="changeCurrentPage">
         </el-pagination>
      </div>

      <el-dialog v-model="dialogVisible" custom-class="dialog-content" :modal-append-to-body="false">
         <el-form label-width="80px" :inline="true" :model="dialogForm">
            <el-form-item :label="status ? '发送邀请' : '变更状态'">
               <el-select v-model="dialogForm.rid" placeholder="请选择">
                  <el-option label="普通用户" :value="0" v-if="status === 0"></el-option>
                  <el-option v-for="item in roles" :key="item.value" :label="item.label"
                     :value="item.value"></el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <span slot="footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="sendUpdate">确 定</el-button>
         </span>
      </el-dialog>

      <el-dialog title="赠送" size="tiny" :modal-append-to-body="false" :destroy-on-close="true"
         v-model="donationDialog.visible">
         <el-form ref="donationFormRef" label-width="100px" label-position="left" :model="donationParam"
            :rules="donationDialog.rules">
            <el-form-item label="选择类型" prop="type">
               <el-select v-model="donationParam.type">
                  <el-option label="体验卡" :value="1"></el-option>
                  <el-option label="会员" :value="2"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="选择体验卡" v-show="donationParam.type == 1" prop="experienceCardId">
               <el-select v-model="donationParam.experienceCardId">
                  <el-option v-for="(item, index) in donationDialog.experienceCardOptions" :key="index"
                     :label="item.label" :value="item.value">
                  </el-option>
               </el-select>
               <div>剩余数量：{{ experienceResidualQuantity }}张</div>
            </el-form-item>
            <el-form-item label="选择会员" v-show="donationParam.type == 2" prop="memberCardId">
               <el-select v-model="donationParam.memberCardId">
                  <el-option v-for="(item, index) in donationDialog.memberCardOptions" :key="index" :label="item.label"
                     :value="item.value">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="体验卡数量" v-show="donationParam.type == 1" prop="count">
               <el-input-number :controls="false" :min="0" :step="1" v-model="donationParam.count"></el-input-number>
               <span>张</span>
            </el-form-item>
         </el-form>
         <template #footer>
            <div class="flex-row-center">
               <el-button @click="donationDialog.visible = false">取消</el-button>
               <el-button type="primary" @click="clickDonationDone">确认</el-button>
            </div>
         </template>
      </el-dialog>
   </div>
</template>

<script>
export default {
   data() {
      const validateExperienceCard = (rule, value, callback) => {
         if (this.donationParam.type == 1 && this.donationParam.experienceCardId === '') {
            return callback(new Error('请选择体验卡'));
         }
         callback();
      };
      const validateMemberCard = (rule, value, callback) => {
         if (this.donationParam.type == 2 && this.donationParam.memberCardId === '') {
            return callback(new Error('请选择会员'));
         }
         callback();
      };
      return {
         loading: false,
         actionUrl: this.$util.domain + '/adminapi/experienceCard/giveCard/import',
         queryParam: {
            pageNum: 1,
            pageSize: 10,
            gender: -1,
            roleId: -1,
            unid: "",
            inviteStatus: -1,
            searchKey: "",
         },
         gender: ["全部", "女", "男"],
         inviteStatus: ["全部", "可邀请", "已邀请", "不可邀请"],
         roles: [],
         campuszones: [],
         tableData: [],
         tableTotal: 0,
         dialogVisible: false,
         status: 0, // 0 变更类型 1 发送邀请
         dialogForm: {
            rid: null,
         },
         donationDialog: {
            visible: false,
            uid: '',
            experienceCardOptions: [],
            memberCardOptions: [],
            rules: {
               type: [{ type: 'number', required: true, message: '请选择类型', trigger: 'blur' }],
               experienceCardId: [{ required: true, validator: validateExperienceCard }],
               memberCardId: [{ required: true, validator: validateMemberCard }],
               count: [{ type: 'number', required: true, message: '请输入数量', trigger: 'blur' }],
            }
         },
         donationParam: {
            type: 1,
            experienceCardId: '',
            memberCardId: '',
            count: 0
         }
      }
   },

   computed: {
      // 体验卡剩余数量
      experienceResidualQuantity() {
         const experienceCard = this.donationDialog.experienceCardOptions.filter((item) => {
            return item.value == this.donationParam.experienceCardId
         })
         if (experienceCard.length) {
            const card = experienceCard[0];
            if (card.quantity == -1) {
               return '∞';
            } else {
               return experienceCard[0].residualQuantity;
            }
         } else {
            return '';
         }
      }
   },

   mounted() {
      this.queryPrivilegeRoles();
      this.queryAllcampuszones();
      this.queryExperienceCardList();
      this.queryMemberCardList();
   },

   methods: {
      // 获取特权角色
      async queryPrivilegeRoles() {
         try {
            const result = await this.$http({
               url: this.$util.domain + "/adminapi/privilege/v1/queryAll",
               method: "GET",
            });
            if (result.body.data && result.body.data.length) {
               this.roles = result.body.data.map((item) => ({
                  label: item.name,
                  value: item.id,
               }));
            } else {
               this.roles = [];
               result.body.error !== 10000 &&
                  this.$message.error(result.body.message || "请联系管理员");
            }
         } catch (error) {
            this.roles = [];
            this.$message.error("请联系管理员");
         }
      },
      //获取所有校区信息
      async queryAllcampuszones() {
         try {
            const result = await this.$http({
               url: this.$util.domain + "/adminapi/v1/basicTools/allCampusZones",
               method: "GET",
            });
            if (result.body.data && result.body.data.length) {
               this.campuszones = result.body.data.map((item) => ({
                  label: item.name,
                  value: item.unid,
               }));
               this.queryParam.unid = this.campuszones[0].value;
               this.queryList();
            } else {
               this.campuszones = [];
               result.body.error !== 10000 &&
                  this.$message.error(result.body.message || "请联系管理员");
            }
         } catch (error) {
            this.campuszones = [];
            this.$message.error("请联系管理员");
         }
      },
      // 获取体验卡列表
      queryExperienceCardList() {
         this.$http({
            url: this.$util.domain + '/adminapi/experienceCard/all',
            method: 'GET',
         }).then((res) => {
            const list = res.data.data || [];
            this.donationDialog.experienceCardOptions = list.map((item) => ({
               label: item.name,
               value: item.id,
               quantity: item.quantity,
               residualQuantity: item.residualQuantity
            }));
         }).catch((err) => {
            this.donationDialog.experienceCardOptions = [];
         })
      },
      // 获取会员列表
      queryMemberCardList() {
         const params = {
            status: 1, // 状态（-1全部 1已发布 2撤销发布）
            pageNum: 1,
            pageSize: 10000,
         }
         this.$http({
            url: this.$util.domain + '/adminapi/privilegeConfig/list',
            method: 'GET',
            params: params
         }).then((res) => {
            const list = res.data.data.models || [];
            this.donationDialog.memberCardOptions = list.map((item) => ({
               label: item.name,
               value: item.id,
            }));
         }).catch((err) => {
            this.donationDialog.memberCardOptions = [];
         })
      },
      // 查询列表
      async queryList() {
         try {
            this.loading = true;
            const result = await this.$http({
               method: "POST",
               url: this.$util.domain + "/adminapi/privilege/v1/user/list",
               dataType: "json",
               body: JSON.stringify({
                  ...this.queryParam,
               }),
            });
            if (result.body.data && JSON.stringify(result.body.data) !== "{}") {
               const { totalElements, content } = result.body.data;
               this.tableTotal = totalElements || 0;
               if (content && content.length) {
                  this.tableData = content;
               } else {
                  this.tableData = [];
               }
            } else {
               this.tableData = [];
               this.tableTotal = 0;
               result.body.error !== 10000 &&
                  this.$message.error(result.body.message || "请联系管理员");
            }
         } catch (error) {
            this.tableData = [];
            this.tableTotal = 0;
         } finally {
            this.loading = false;
         }
      },
      // 发送邀请、变更类型确定提交
      async sendUpdate() {
         try {
            let url = "";
            let params = {};
            if (this.status === 1) {
               url = "/adminapi/privilege/v1/invite/add";
               params = {
                  uid: this.dialogForm.uid,
                  roleId: this.dialogForm.rid,
               };
            } else {
               url = "/adminapi/privilege/v1/invite/updateType";
               params = this.dialogForm;
            }
            const result = await this.$http({
               method: "POST",
               url: this.$util.domain + url,
               body: JSON.stringify({
                  ...params,
               }),
            });
            if (result.body.error !== 10000) {
               this.$message({
                  type: "error",
                  message: result.body.message,
               });
               return;
            }
            this.dialogVisible = false;
            this.queryList();
         } catch (error) {
            this.$message({
               type: "error",
               message: "请联系管理员",
            });
         }
      },
      // 发送赠送
      sendDonation() {
         this.loading = true;
         let url = '';
         let params = {
            uid: this.donationDialog.uid,
         }
         if (this.donationParam.type == 1) {
            url = this.$util.domain + '/adminapi/experienceCard/give';
            params['cardId'] = this.donationParam.experienceCardId;
            params['num'] = this.donationParam.count;
         } else if (this.donationParam.type == 2) {
            url = this.$util.domain + '/adminapi/privilege/v1/send';
            params['privilegeConfigId'] = this.donationParam.memberCardId * 1;
         }
         this.$http({
            url: url,
            method: 'POST',
            dataType: 'json',
            body: params
         }).then((res) => {
            if (res.body.error === 10000) {
               this.donationDialog.visible = false;
               this.$util.successMsg(res.body.message);
               this.queryList();
            } else {
               this.$util.errorMsg(res.body.message);
            }
         }).catch((err) => {
            this.$message.error(err.message || "请联系管理员");
         }).finally(() => {
            this.loading = false;
         })
      },
      // 重置
      clickReset() {
         this.queryParam = {
            pageNum: 1,
            pageSize: 10,
            gender: -1,
            roleId: -1,
            unid: this.campuszones[0].value || "",
            inviteStatus: -1,
            searchKey: "",
         };
         this.queryList();
      },
      // 点击模板下载
      clickTemplateDownload() {
         location.href = "https://admin.gxapp.iydsj.com/template/importCard.xls";
      },
      // 导入之前
      beforeUpload() {
         this.loading = true;
      },
      //导入成功
      onSuccess(response) {
         this.loading = false;
         if (response.error !== 10000) {
            this.$util.errorMsg(response.message);
         } else if (response.data && JSON.stringify(response.data) !== '{}') {
            if (response.data.failRecord.length > 0) {
               this.$util.errorMsg(response.data.failRecord.join(';'));
            } else {
               this.$util.successMsg("导入成功");
               this.getList();
            }
         } else {
            this.$util.successMsg("导入成功");
            this.getList();
         }
      },
      //导入失败
      onError(response) {
         this.loading = false;
         if (response.status === 403) {
            this.SIGNOUT();
            location.href = "/#";
         }
         this.$util.errorMsg("导入失败");
      },
      // 切换页数
      changeCurrentPage(val) {
         this.queryParam.pageNum = val;
         this.queryList();
      },
      // 发送邀请
      clickInvitation(row) {
         this.status = 1;
         this.dialogForm = {
            uid: row.uid,
            roleId: null,
         };
         this.dialogVisible = true;
      },
      // 变更类型
      clickChangeType(row) {
         this.status = 0;
         this.dialogForm = {
            uid: row.uid,
            id: row.id,
            rid: null,
         };
         this.dialogVisible = true;
      },
      // 撤销
      async clickRevoke(row) {
         try {
            const result = await this.$http({
               method: "POST",
               url: this.$util.domain + "/adminapi/privilege/v1/invite/delete",
               body: JSON.stringify({
                  inviteId: row.id,
               }),
            });
            if (result.body.error == 10000) {
               this.queryList();
            } else {
               this.$message({
                  type: "error",
                  message: result.body.message,
               });
            }
         } catch (error) {
            this.$message({
               type: "error",
               message: "操作失败",
            });
         }
      },
      // 点击赠送
      clickDonate(row) {
         this.donationDialog.visible = true;
         this.donationDialog.uid = row.uid;
      },
      // 点击赠送弹框确认按钮
      clickDonationDone() {
         this.$refs.donationFormRef.validate((valid) => {
            if (valid) {
               this.sendDonation();
            }
         });
      },

   },
}
</script>

<style scoped>
.action-wrapper {
   gap: 10px;
}
</style>


// WEBPACK FOOTER //
// UserListing.vue?e8917ace